export const SNACKBAR_TYPES = {
  SNACKBAR_SUCCESS: "success",
  SNACKBAR_WARNING: "warning",
  SNACKBAR_ERROR: "error",
  SNACKBAR_INFO: "info",
};
